<div class="create-match-container">
    <h2>Establecer jugador en final</h2>
    <div style="text-align: center; margin: 1rem;">
        <h3>{{stage}} - {{match}} - {{player}}</h3>
    </div>

    <form [formGroup]="form" (ngSubmit)="submit()">

        <mat-form-field appearance="fill">
            <mat-label>Jugador</mat-label>
            <input matInput formControlName="playerId" />
        </mat-form-field>

        <div class="buttons">
            <button matButton="filled" type="submit" [disabled]="form.invalid">Guardar</button>
            <button matButton="outlined" type="button" (click)="exit()">Salir</button>
        </div>
    </form>
</div>